function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyberhawkLogoBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 526.95999 93.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.97,25.74c21.4.33,40.45,3,55.6,9.57.05.23-.26.36-.39.47-1.16.9-2.65,1.86-3.86,2.79-14.16-5.9-31.6-8.51-51.42-8.77V25.94C22.89,25.85,22.89,25.8,22.97,25.74Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.37,46.67a46.30381,46.30381,0,0,1-4.65,2.53C65.99,43,53.26,39.8,38.58,38.57a32.43943,32.43943,0,0,1,1.66-3.59c0-.06,0-.28.13-.13a140.37987,140.37987,0,0,1,21.79,4.11C68.92,40.85,75.16,43.19,80.37,46.67Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,40.96c14.34.49,27.58,2.09,38.53,6,.08.16-.17.32-.27.4-.94.74-2.26,1.48-3.25,2.25-9.7-3.81-22.39-4.68-35.21-5.33,0-1,.1-2.07.13-3.12C23.03,41.06,23.02,40.97,23.1,40.96Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.72,47.87c5,.78,10,1.66,14.74,2.79S58.72,53,62.3,55.31c-1.23.75-2.61,1.34-3.86,2.06C51.33,53.94,42.72,52,33.26,50.92A24.54077,24.54077,0,0,1,34.72,47.87Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72,56.7a17.99938,17.99938,0,0,1-2.66,2.26c-2.89-1.37-6.46-1.95-10.23-2.39S27,55.93,23,55.77a19.8198,19.8198,0,0,1,.07-2.59C32.09,53.58,40.72,54.3,47.72,56.7Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.72,62.88c-1.06.4-2,.92-3,1.4-4.23-1.87-9.67-2.52-14.95-3.32a14.99992,14.99992,0,0,1,1.2-2.33c5.41.66,10.77,1.47,15.08,3.32A4,4,0,0,1,46.72,62.88Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.39,64.61a14.82045,14.82045,0,0,1-2.13,2.06c-3.23-1.07-7.24-1.36-11.36-1.53V63.08A47.59964,47.59964,0,0,1,36.39,64.61Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.66,68.93a23.05116,23.05116,0,0,1-2.39,1.53,28,28,0,0,0-6.25-1.33,15.0006,15.0006,0,0,1,.93-1.73A17.3,17.3,0,0,1,33.66,68.93Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.11,84.44a38.31,38.31,0,0,1,0-76.51v-5a43.26,43.26,0,0,0,0,86.43Z",
    style: {
      fill: "#ffd12e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.25,2.97v5a38.31,38.31,0,0,1,0,76.51v5a43.26,43.26,0,0,0,0-86.43Z",
    style: {
      fill: "#ffd12e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.05,67.73a13.89,13.89,0,0,1-10-4.07c-3.68-3.67-3.68-7.51-3.68-15.79s0-12.13,3.68-15.8a13.92,13.92,0,0,1,10-4.06c7,0,12.24,4.28,13.55,11.63h-4.28c-1-4.77-4.38-7.9-9.27-7.9a9.39,9.39,0,0,0-6.74,2.75c-2.47,2.52-2.75,5.21-2.75,13.38s.28,10.86,2.75,13.38a9.38005,9.38005,0,0,0,6.74,2.74c4.89,0,8.34-3.12,9.38-7.89h4.17C139.34,63.45,134.02,67.73,127.05,67.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.57,51.27V67.4H167.4V51.27L155.77,28.34h4.5l9.22,18.7,9.1-18.7h4.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.09,67.4h-15.2V28.34h14.7c6.81,0,11.53,3.9,11.53,10.42a9,9,0,0,1-5.77,8.56,9.46,9.46,0,0,1,6.37,9.27C227.72,63.66,223,67.4,216.09,67.4Zm-.82-35.33H205.06V45.62h10.21c4.33,0,7.68-2.14,7.68-6.8s-3.35-6.75-7.68-6.75Zm.45,17.28H205.06V63.66h10.66c4.82,0,7.84-2.79,7.84-7.18S220.53,49.35,215.72,49.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.25,67.4V28.34H273.5v3.73H253.42V45.8h17.12v3.73H253.42V63.66H273.5V67.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.31,67.4l-8.88-17.34h-9.38V67.4h-4.17V28.34h15c6.81,0,11.58,4.12,11.58,10.86a10.13,10.13,0,0,1-8.51,10.48l9.28,17.72Zm-7.84-35.33H298.05V46.39h10.42c4.55,0,7.79-2.36,7.79-7.14S313.02,32.07,308.47,32.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.32,67.4V51.05H348.1V67.4h-7.62V28.34h7.62v16h13.22v-16h7.63V67.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.98,67.4l-2.26-6.91H395.8l-2.36,6.91h-8l14.28-39.06h6L419.94,67.4Zm-9.1-27.54-4.94,14.21h9.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.29,67.4h-6.36l-7.21-23.7-7.18,23.7h-6.37l-10.4-39.06h7.95l6,24.63,7.13-24.63h5.7l7.17,24.63,6.08-24.63h8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.07,67.4l-10-17.78-5.05,6V67.4H495.4V28.34h7.62v17l13.77-17h9.27L513.08,43.86,526.96,67.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.75,
    cy: 46.75,
    r: 46.75,
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.43,28.3c19.62.3,37.07,2.75,50.95,8.77,0,.21-.24.33-.37.43-1.06.82-2.43,1.71-3.53,2.55-13-5.4-29-7.79-47.13-8V28.49C25.35,28.42,25.34,28.32,25.43,28.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.01,47.49a42.51352,42.51352,0,0,1-4.29,2.31c-8.92-5.68-20.57-8.6-34-9.74a30.57059,30.57059,0,0,1,1.51-3.26s0-.25.13-.12a127.93087,127.93087,0,0,1,20,3.76C67.52,42.14,73.24,44.29,78.01,47.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54,42.26c13.14.45,25.27,1.91,35.3,5.47.07.16-.15.3-.24.38-.87.68-2.07,1.36-3,2.07-8.88-3.49-20.47-4.28-32.26-4.87,0-1,.1-1.89.13-2.85C25.47,42.34,25.47,42.26,25.54,42.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.19,48.58c4.53.71,9.19,1.52,13.53,2.55s8.46,2.15,11.75,4.26c-1.12.69-2.38,1.23-3.53,1.87-6.52-3.14-14.4-4.92-23.07-5.9A21.55064,21.55064,0,0,1,36.19,48.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,56.67a16.09064,16.09064,0,0,1-2.4,2.07,30.27,30.27,0,0,0-9.37-2.19c-3.46-.41-7.17-.59-10.84-.75a15.29952,15.29952,0,0,1,.06-2.37C33.78,53.8,41.72,54.47,48.12,56.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,62.33a28.84341,28.84341,0,0,0-2.74,1.28c-3.88-1.71-8.86-2.3-13.7-3a13.4191,13.4191,0,0,1,1.1-2.13c5,.6,9.87,1.34,13.81,3A3.71,3.71,0,0,1,47.21,62.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.72,63.91a12.7699,12.7699,0,0,1-2,1.89,39.83987,39.83987,0,0,0-10.41-1.4V62.5A43.64014,43.64014,0,0,1,37.72,63.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.22,67.87a24.23932,24.23932,0,0,1-2.2,1.4,26.74034,26.74034,0,0,0-5.72-1.22,12.6497,12.6497,0,0,1,.86-1.58A15.94,15.94,0,0,1,35.22,67.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.79,82.08a35.1,35.1,0,0,1,0-70.1V7.44a39.65,39.65,0,0,0,0,79.19Z",
    style: {
      fill: "#ffd213"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.58,7.44v4.54a35.1,35.1,0,0,1,0,70.1v4.55a39.65,39.65,0,0,0,0-79.19Z",
    style: {
      fill: "#ffd213"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberhawkLogoBottom);
export default __webpack_public_path__ + "static/media/cyberhawk-logo-bottom.4add211ff4f8a57fcafab21e6b774bca.svg";
export { ForwardRef as ReactComponent };